import {
  createConversationAPI,
  sendMessageAPI,
  getMessagesAPI,
  sendAttachmentAPI,
  toggleTyping,
  setUserLastSeenAt
} from 'widget/api/conversation';

import HiverApi from 'widget/api/hiver';

import { createTemporaryMessage, getNonDeletedMessages } from './helpers';

import { FILE_UPLOAD_ERROR } from 'shared/constants/messages';
import { BUS_EVENTS } from 'shared/constants/busEvents';

import { sendExceptionToSentry } from 'shared/helpers/sentry';
import { sendGainSightEvent, CHATBOTS_GAINSIGHT_EVENTS, GAIN_SIGHT_CONSTANTS } from '../../../../gainSightIntegration';

export const actions = {
  createConversation: async ({ commit, dispatch }, params) => {
    commit('setConversationUIFlag', { isCreating: true });
    try {
      commit('setConversationListLoading', true);
      const { data } = await createConversationAPI(params);
      const { messages } = data;
      const [message = {}] = messages;
      commit('pushMessageToConversation', message);
      await dispatch('conversationAttributes/getAttributes', {}, { root: true });
      commit('setConversationListLoading', false);
      return data;
    } catch (error) {
      sendExceptionToSentry(error);
    } finally {
      commit('setConversationUIFlag', { isCreating: false });
    }
  },
  sendMessage: async ({ commit }, params) => {
    const { content } = params;
    commit('pushMessageToConversation', createTemporaryMessage({ content }));
    return await sendMessageAPI(content);
  },

  sendAttachment: async ({ commit }, params) => {
    const {
      attachment: { thumbUrl, fileType }
    } = params;
    const attachment = {
      thumb_url: thumbUrl,
      data_url: thumbUrl,
      file_type: fileType,
      status: 'in_progress'
    };
    const tempMessage = createTemporaryMessage({
      attachments: [attachment]
    });

    commit('pushMessageToConversation', tempMessage);
    try {
      const { data } = await sendAttachmentAPI(params);
      commit('updateAttachmentMessageStatus', {
        message: data,
        tempId: tempMessage.id
      });
    } catch (error) {
      commit('deleteMessage', tempMessage.id);
      window.bus.$emit(BUS_EVENTS.SHOW_ALERT, {
        message: FILE_UPLOAD_ERROR
      });
      sendExceptionToSentry(error);
    }
  },
  fetchOldConversations: async ({ commit }, { before } = {}) => {
    try {
      commit('setConversationListLoading', true);
      const { data } = await getMessagesAPI({ before });
      const formattedMessages = getNonDeletedMessages({
        messages: data.payload ? data.payload : data
      });
      commit('setMessagesInConversation', formattedMessages);
      commit('setConversationListLoading', false);
    } catch (error) {
      commit('setConversationListLoading', false);
      sendExceptionToSentry(error);
    }
  },

  setConversationsListLoading: ({ commit }, value) => {
      commit('setConversationListLoading', value);
  },

  clearConversations: ({ commit }) => {
    commit('clearConversations');
  },

  addOrUpdateMessage: async ({ commit }, data) => {
    const { id, content_attributes } = data;
    if (content_attributes && content_attributes.deleted) {
      commit('deleteMessage', id);
      return;
    }
    commit('pushMessageToConversation', data);
  },

  toggleAgentTyping({ commit }, data) {
    commit('toggleAgentTypingStatus', data);
  },

  toggleUserTyping: async (_, data) => {
    try {
      await toggleTyping(data);
    } catch (error) {
      sendExceptionToSentry(error);
    }
  },

  setUserLastSeen: async ({ commit, getters: appGetters }) => {
    if (!appGetters.getConversationSize) {
      return;
    }

    const lastSeen = Date.now() / 1000;
    try {
      commit('setMetaUserLastSeenAt', lastSeen);
      await setUserLastSeenAt({ lastSeen });
    } catch (error) {
      sendExceptionToSentry(error);
    }
  },

  registerChatsbotService: async (_, params) => {
    const { conversationId, inboxId, triggerType, nudgeId } = params;
    const response = await HiverApi.registerChatbotsConversationType(
      conversationId,
      inboxId,
      triggerType,
      nudgeId
    );
    if(response?.status === GAIN_SIGHT_CONSTANTS.RESPONSE_STATUS_200) {
      sendGainSightEvent(CHATBOTS_GAINSIGHT_EVENTS.CHATBOT_FLOW_TRIGGERED, {triggerType});
    }
  }
};
